module.exports = __webpack_public_path__ + "static/media/pacific.7749ed1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/pacific.png
// module id = 127
// module chunks = 0